import { toast } from "react-toastify";
import IntegrationService from "../../../../services/IntegrationService";
import intl from "../../../../i18n/intl";
import { errorMessageId } from "../../../../helpers/ErrorMessage";

const customIntl = intl();

// AI Write is offered when the organisation has a Google Gemini key stored.
// The integration lookup never returns the key itself (it stays on the
// server), only "api_key_set": "true".
export const isAiWriteAvailable = (integrations) =>
  integrations?.Google_Gemini?.api_key_set === "true";

// The message for a failed AI Write: the API's error code when there is a
// message for it (AI_NOT_CONFIGURED, AI_REQUEST_FAILED, TEXT_TOO_LONG), otherwise the
// general one.
const failureMessageId = (error) =>
  errorMessageId(error?.response?.data, customIntl, "ai_write_failed");

// The AI Write toolbar button of the notification editors (add and edit):
// the API has Gemini correct the editor's text (the key and the instructions
// stay on the server) and the answer replaces the text. On any failure the
// admin's text is left as it was and an error is shown.
export const runAiWrite = async (editor) => {
  const text = editor.getContent();
  if (!text.trim()) {
    alert("Please enter some content in the editor first!");
    return;
  }

  try {
    const response = await IntegrationService.aiWrite({ text });
    const corrected = response?.data?.response?.text;
    if (typeof corrected === "string" && corrected.trim()) {
      editor.setContent(corrected);
    } else {
      toast.error(customIntl.formatMessage({ id: "ai_write_failed" }));
    }
  } catch (error) {
    toast.error(customIntl.formatMessage({ id: failureMessageId(error) }));
  }
};
